import { useQuery, UseQueryResult } from '@tanstack/react-query';
import {
	TestEvidenceApiService,
	RunListResult,
	RunDetail,
	ListRunsParams,
} from '../../../services/testEvidenceApi';

/** List test-evidence runs (dashboard), filtered by module / environment / prOnly. */
export const useTestRuns = (params: ListRunsParams = {}): UseQueryResult<RunListResult, Error> => {
	return useQuery({
		queryKey: ['test-evidence', 'runs', params.module, params.environment, params.prOnly, params.page],
		queryFn: () => TestEvidenceApiService.listRuns(params),
		staleTime: 0,
		refetchOnWindowFocus: false,
	});
};

/** One run's detail + screenshots. Enabled only when a run is selected. */
export const useTestRun = (runId?: number): UseQueryResult<RunDetail, Error> => {
	return useQuery({
		queryKey: ['test-evidence', 'run', runId],
		queryFn: () => TestEvidenceApiService.getRun(runId as number),
		enabled: !!runId,
		staleTime: 0,
		refetchOnWindowFocus: false,
	});
};
